//
// Action types
//

export const UPDATE_RESOURCES_LIST_ITEMS_COUNT = "UPDATE_RESOURCES_LIST_ITEMS_COUNT";

//
// Action creators
//

export function updateResourcesListItemsCount(resourcesListKey, count) {
  return {
    type: UPDATE_RESOURCES_LIST_ITEMS_COUNT,
    resourcesListKey,
    count
  };
}

function updateResourcesListItemsCountHandler(state, count) {
  return { ...state, count };
}

//
// Reducer and handlers
//

export function reduceItems(state, action) {
  switch (action && action.type) {
    case UPDATE_RESOURCES_LIST_ITEMS_COUNT:
      return updateResourcesListItemsCountHandler(state, action.count);
    default:
      return state || { count: 0 };
  }
}
